import FormMutationTypes from './FormMutationTypes';

const FormMutations = {
  [FormMutationTypes.UPDATE_LOADING_STATE](state, loadingState) {
    state.isLoading = loadingState;
  },
  [FormMutationTypes.UPDATE_TEMPLATES](state, templates) {
    state.templates = templates;
  },
  [FormMutationTypes.UPDATE_FORMS](state, forms) {
    state.forms = forms;
  },
  [FormMutationTypes.UPDATE_FORMS_TO_BE_REMOVED](state, formsToBeRemoved) {
    state.formsToBeRemoved = formsToBeRemoved;
  },
  [FormMutationTypes.UPDATE_WORK_ORDER_FORM_ID](state, workOrderFormId) {
    state.workOrderFormId = workOrderFormId;
  },
};

export default FormMutations;
